import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from '../actions';
import { CoreState } from '../types';
import * as handlers from './handlers';

type ActionTypes = ActionType<typeof actions>;

const CORE_INITIAL_STATE: CoreState = {
  color: undefined,
};

export const aspectReducer = createReducer<CoreState, ActionTypes>(CORE_INITIAL_STATE).handleAction(
  actions.setColor,
  handlers.setColor,
);
